import * as React from 'react';
import * as Yup from 'yup';
import { isEqual } from 'lodash';

import {
  IUser,
  IFormProps,
  IFormState,
  IonToggleMarket,
  IonChangeName,
} from '../types';

import EditForm from './EditForm';
import { toggleRole } from 'src/services/authorizeUser';
import { USER_ROLE } from 'src/services/user/types';

export default class Form extends React.Component<IFormProps, IFormState> {
  state: IFormState = {
    isSubmitting: false,
    submitError: '',
    validationErrors: [],
    isValid: true,
    dirty: false,
    values: {} as IUser,
  };

  schema = Yup.object().shape({
    email: Yup.string().required('Username is required.'),
  });

  componentDidMount() {
    this.setState({
      values: this.props.initialValues,
    });
  }

  onSubmit = async () => {
    this.setState({ isSubmitting: true, submitError: '' });
    this.props.preventClosing(false);
    try {
      await this.props.onSubmit(this.state.values as IUser);
    } catch (error) {
      if (error.response.data.errorMessage === 'user_already_exists') {
        this.setState({ submitError: 'User already exists.' });
      }
    }
  };

  handleValueChange = () => {
    this.validateValues();
    this.updateDirty();
  };

  validateValues = () => {
    this.setState({ validationErrors: [] });
    this.schema
      .validate(this.state.values)
      .then(() => {
        this.setState({ isValid: true });
      })
      .catch(({ errors }: any) => {
        this.setState({ validationErrors: errors, isValid: false });
      });
  };

  updateDirty = () => {
    const dirty = !isEqual(this.props.initialValues, this.state.values);
    this.props.preventClosing(dirty);
    this.setState({
      dirty,
    });
  };

  onChangeName: IonChangeName = (name) => {
    this.setState(
      (state) => ({
        values: { ...state.values, email: name },
      }),
      this.handleValueChange
    );
  };

  onToggleRole = (role: USER_ROLE) => () => {
    this.setState(
      (state) => ({
        values: {
          ...state.values,
          roles: toggleRole(state.values.roles, role),
        },
      }),
      this.handleValueChange
    );
  };

  onToggleMarket: IonToggleMarket = (field) => (valueOrAll, checked) => () => {
    this.setState((state) => {
      let newValues;
      if (typeof valueOrAll === 'object') {
        newValues = checked
          ? state.values[field].filter(
              (market: any) => market.id !== valueOrAll.id
            )
          : [...state.values[field], valueOrAll];
      } else {
        newValues = valueOrAll ? this.props.markets : [];
      }

      return {
        values: {
          ...state.values,
          [field]: newValues,
        },
      };
    }, this.handleValueChange);
  };

  render() {
    if (!this.state.values.roles) {
      return null;
    }
    return (
      <EditForm
        id={this.props.id}
        markets={this.props.markets}
        onSubmit={this.onSubmit}
        onChangeName={this.onChangeName}
        onToggleRole={this.onToggleRole}
        onToggleMarket={this.onToggleMarket}
        {...this.state}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Users/components/Form.tsx